import script from "./TasksPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TasksPage.vue?vue&type=script&setup=true&lang=ts"

import "./TasksPage.vue?vue&type=style&index=0&id=04eedef1&lang=scss"

const __exports__ = script;

export default __exports__